import React from 'react';
import { IonCard, IonList, IonListHeader, IonLabel } from '@ionic/react';
import UpcomingHolidayRow from './UpcomingHolidayRow';
import { Holiday } from '../../../models/classes.model';
import './UpcomingHolidaysSection.css';

interface Props {
    holidays: Holiday[];
}

const UpcomingHolidaysSection: React.FC<Props> = ({ holidays }) => {
    if (holidays.length === 0) {
        return null;
    }

    return (
        <IonCard className="upcoming-holidays-section">
            <IonList lines="full">
                <IonListHeader>
                    <IonLabel>Upcoming Holidays</IonLabel>
                </IonListHeader>
                {holidays.map(holiday => (
                    <UpcomingHolidayRow key={`upcoming-holiday-${holiday.id}`} holiday={holiday} />
                ))}
            </IonList>
        </IonCard>
    );
};

export default UpcomingHolidaysSection;
